import { SxProps, Theme } from "@mui/material";

export const container: SxProps<Theme> = {
    position: "absolute",
    top: "20%",
    right: 0,
    transform: "translateY(-20%)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    overflow: "hidden",
    height: "50%",
};

export const sliderButton: SxProps<Theme> = {
    backgroundColor: "#fff",
    cursor: "pointer",
    borderRadius: "4px 0 0 0",
    width: "100%",
    "&:hover": {
        backgroundColor: "#f5f5f5",
    },
};

export const sliderParent = (showScrollbar: boolean): SxProps<Theme> => ({
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    cursor: "pointer",
    overflowY: showScrollbar ? "auto" : "hidden",
    borderRadius: "0 0 0 4px",

    "&::-webkit-scrollbar": {
        width: showScrollbar ? "8px" : "0",
    },
    "&::-webkit-scrollbar-track": {
        backgroundColor: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#9e9d9b",
    },
    "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "#555",
    },
});

export const sliderItem: SxProps<Theme> = {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
    gap: 1,
    p: 1,
    cursor: "pointer",
};

export const activeSliderItem: SxProps<Theme> = {
    backgroundColor: "#fff",
};

export const avatar: SxProps<Theme> = {
    width: 50,
    height: 50,
    borderRadius: "50%",
    backgroundColor: "primary.main",
    p: 1,
};

export const detailsInfo: SxProps<Theme> = {
    display: "flex",
    flexDirection: "column",
};
